import React from 'react';
import { Form, Card } from 'react-bootstrap';
import { useScannerSettings } from '../providers/ScannerSettingsContext';
import BackButton from './BackButton';

const SettingsPage = () => {
  const { scannerType, setScannerType } = useScannerSettings();

  const onChange = e => setScannerType(e.target.value);

  return (
    <Card className="p-4">
      <BackButton />
      <h2>Barcode Scanner Settings</h2>
      <Form>
        <Form.Group>
          <Form.Label>Which scanner should we use?</Form.Label>
          <div>
            <Form.Check
              inline
              type="radio"
              id="scanner-mobile"
              name="scannerType"
              label="Mobile Camera"
              value="mobile"
              checked={scannerType === 'mobile'}
              onChange={onChange}
            />
            <Form.Check
              inline
              type="radio"
              id="scanner-bluetooth"
              name="scannerType"
              label="Bluetooth Scanner"
              value="bluetooth"
              checked={scannerType === 'bluetooth'}
              onChange={onChange}
            />
          </div>
        </Form.Group>
      </Form>
    </Card>
  );
};

export default SettingsPage;
